import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { PageNotfoundComponent } from './shared/page-notfound/page-notfound.component';
import { AuthGuard } from '@bcone/neo-app-sdk';
import { AppConstants } from './constants/app-constants';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: AppConstants.PAGE_TITLES.LOGIN }
  },
  {
    path: 'user-and-file-audit',
    loadChildren: './user-and-file-audit/user-and-file-audit.module#UserAndFileAuditModule',
    canActivate: [AuthGuard],
    data: { title: AppConstants.PAGE_TITLES.USER_AND_FILE_AUDIT }
  },
  {
    path: 'error-and-warning-audit',
    loadChildren: './error-and-warning-audit/error-and-warning-audit.module#ErrorAndWarningAuditModule',
    canActivate: [AuthGuard],
    data: { title: AppConstants.PAGE_TITLES.ERROR_AND_WARNING_AUDIT }
  },
  {
    path: 'page-not-found',
    component: PageNotfoundComponent,
    pathMatch: 'full',
    data: { title: AppConstants.PAGE_TITLES.PAGE_NOT_FOUND }
  },
  {
    path: '',
    redirectTo: '/user-and-file-audit',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PageNotfoundComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
